import { render } from "./AllProducts.vue?vue&type=template&id=0232fa22&scoped=true"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"

import "./AllProducts.vue?vue&type=style&index=0&id=0232fa22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0232fa22"]])

export default __exports__